import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "TipoPagoPage",
    data() {
        let ss = new MainService();
        return {
            msg: "TipoPagoPage",
            ss: ss,
            ajax: {
                "url": ss.indexTipoPago(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N', orderable: false, searchable: false },
                { data: 'TipoPago', name: 'TipoPago', title: 'Tipo de Pago' },
                { data: 'Codigo', name: 'Codigo', title: 'Código' },
                { data: 'Descripcion', name: 'Descripcion', title: 'Descripción'},
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],
            tipoPagos: [],
            tipoPago: {},
            isLoading: false,
            errorBag: {}
        };
    },
    methods: {
        newTipoPago() {
            this.tipoPago = {};
            this.$refs['frm-tipoPago'].show();
        },
        showTipoPago(id) {
            this.isLoading=true;
            this.ss.showTipoPago(id).then(
                (result) => {
                    let response = result.data;
                    this.tipoPago = response.data;
                    this.$refs['view-tipoPago'].show();
                    this.isLoading=false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading=false;
            });
        },
        editTipoPago() {
            this.$refs['frm-tipoPago'].show();
            this.$refs['view-tipoPago'].hide();
        },
        cancelTipoPago() {
            if (this.tipoPago.id) {
                this.$refs['view-tipoPago'].show();
            }
            this.$refs['frm-tipoPago'].hide();
        },
        saveTipoPago() {
            this.ss.storeTipoPago(this.tipoPago).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-tipoPago'].hide();
                    this.$refs['datatable-tipoPago'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        deleteTipoPago() {
            this.$swal({
                title: "Estas seguro que deseas eliminar?",
                text: "Esta accion es irreversible!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
                showCancelButton: true,
                cancelButtonColor: '#d33',
            })
                .then((willDelete) => {
                    if (willDelete.isConfirmed) {
                        this.ss.destroyTipoPago(this.tipoPago)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['view-tipoPago'].hide();
                                this.$refs['datatable-tipoPago'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },
        draw() {
            window.$('.btn-datatable-TipoPago').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                this.showTipoPago(data);
            });
        }
    },
    components: {
        dataTable,
        Loader
    },
    mounted() {
        var persona = JSON.parse(localStorage.getItem('persona'));
        if (!persona) {
          this.$router.push('/Login');
        }
    }
};
